// extracted by mini-css-extract-plugin
export default {"root":"classes_root__Ibmsv","cross":"classes_cross__5XMlb"};